import React from 'react';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-r from-blue-50 to-blue-100 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="lg:w-1/2 mb-10 lg:mb-0">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Discover My Complete Book Collection
            </h1>
            <p className="text-xl text-gray-700 mb-8">
              Explore over 40 published works spanning AI, business development, real estate, finance, and personal growth. Each book is crafted to provide practical insights and actionable strategies.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5/allbooks"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                View on Amazon
              </a>
              <a
                href="https://www.barnesandnoble.com/s/%22Jeffery%20William%20Long%22?Ntk=P_key_Contributor_List&Ns=P_Sales_Rank&Ntx=mode+matchall"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                View on Barnes & Noble
              </a>
              <button className="border border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
                Browse Categories
              </button>
            </div>
          </div>
          
          <div className="lg:w-1/2 flex justify-center lg:justify-end relative">
            <div className="relative">
              <div className="w-80 h-80 rounded-full overflow-hidden border-8 border-white shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/5e204e36ebc4b00a629abaabcc345455.png"
                  alt="Jeffery Long - Author"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Floating decorative elements */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-book-open-line text-white text-2xl"></i>
              </div>
              <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-quill-pen-line text-gray-800 text-xl"></i>
              </div>
              <div className="absolute top-1/2 -left-8 w-10 h-10 bg-green-400 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-star-fill text-white text-lg"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
